import axios, { AxiosResponse } from 'axios';

const path = process.env.NODE_ENV === 'development' ? '/api' : '';

export const serverAxios = axios.create({
  baseURL: `${window.location.protocol}//${window.location.hostname}:${window.location.port}${path}`,
});

serverAxios.interceptors.response.use((response: AxiosResponse): AxiosResponse => {
  if (response.status !== 200) {
    throw response.status;
  }

  return response;
});
